// Native lazy loading fetches several screens ahead on mobile. Keep collection
// thumbnails close to the viewport so they do not delay the category heading.
if (!customElements.get('bc-deferred-preview')) {
  customElements.define('bc-deferred-preview', class extends HTMLElement {
    connectedCallback() {
      const load = () => {
        this.observer?.disconnect();
        const template = this.querySelector('template');
        if (template) this.replaceChildren(template.content.cloneNode(true));
      };
      if (!('IntersectionObserver' in window)) return load();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, {rootMargin: '200px 0px'});
      this.observer.observe(this.parentElement);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
